import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp, query, onSnapshot, orderBy, deleteDoc, doc } from 'firebase/firestore';
import '../Admin.css';

const allIcons = [
  { icon: 'fas fa-tshirt', label: 'wash tshirt clothing' },
  { icon: 'fas fa-iron', label: 'iron steam press' },
  { icon: 'fas fa-wind', label: 'dry clean wind air' },
  { icon: 'fas fa-socks', label: 'socks small' },
  { icon: 'fas fa-scroll', label: 'curtains scroll' },
  { icon: 'fas fa-boot', label: 'shoe care boot' },
  { icon: 'fas fa-rug', label: 'carpet rug' },
  { icon: 'fas fa-shopping-bag', label: 'bag care' },
  { icon: 'fas fa-cut', label: 'alteration tailor cut' },
  { icon: 'fas fa-bed', label: 'bedding bed sheet' },
  { icon: 'fas fa-blanket', label: 'blanket quilt' },
  { icon: 'fas fa-soap', label: 'eco wash soap' },
  { icon: 'fas fa-bolt', label: 'express fast bolt' },
  { icon: 'fas fa-hands-wash', label: 'hand wash' },
  { icon: 'fas fa-suitcase', label: 'leather suitcase' },
  { icon: 'fas fa-box-open', label: 'folded box' },
  { icon: 'fas fa-user-tie', label: 'suits formal tie' },
  { icon: 'fas fa-hat-cowboy', label: 'cap hat' },
  { icon: 'fas fa-mask', label: 'silk care mask' },
  { icon: 'fas fa-broom', label: 'home clean broom' },
  { icon: 'fas fa-spray-can', label: 'stain removal spray' },
  { icon: 'fas fa-sync', label: 'quick cycle refresh' },
  { icon: 'fas fa-baby', label: 'baby wear' },
  { icon: 'fas fa-star', label: 'premium star luxury' }
];

function AddServices() {
  const [serviceName, setServiceName] = useState('');
  const [selectedIcon, setSelectedIcon] = useState(allIcons[0].icon);
  const [actualPrice, setActualPrice] = useState('');
  const [offerPrice, setOfferPrice] = useState('');
  const [services, setServices] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [iconSearchTerm, setIconSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const q = query(collection(db, "services"), orderBy("createdAt", "asc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setServices(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    return () => unsubscribe();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await addDoc(collection(db, "services"), {
        name: serviceName,
        icon: selectedIcon,
        actualPrice: Number(actualPrice),
        offerPrice: Number(offerPrice),
        createdAt: serverTimestamp()
      });
      setServiceName('');
      setActualPrice('');
      setOfferPrice('');
      setSelectedIcon(allIcons[0].icon);
    } catch (error) {
      console.error("Error: ", error);
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure?")) {
      await deleteDoc(doc(db, "services", id));
    }
  };

  // Improved Search Logic: ലേബലിലും ഐക്കൺ ക്ലാസ്സിലും സെർച്ച് ചെയ്യുന്നു
  const filteredIcons = allIcons.filter(item => 
    item.label.toLowerCase().includes(iconSearchTerm.toLowerCase()) ||
    item.icon.toLowerCase().includes(iconSearchTerm.toLowerCase())
  );

  return (
    <div className="add-services-container">
      
      {/* Form Section */}
      <section className="form-section">
        <div className="form-card-full">
          <div className="form-header">
            <h3><i className="fas fa-plus-circle"></i> Add New Service</h3>
          </div>
          
          <form onSubmit={handleSubmit} className="horizontal-form">
            <div className="form-row">
              <div className="input-group">
                <label>Service Name</label>
                <input type="text" value={serviceName} onChange={(e)=>setServiceName(e.target.value)} placeholder="e.g. Dry Cleaning" required />
              </div>

              <div className="input-group">
                <label>Select Icon</label>
                <div className="icon-trigger-fancy" onClick={() => setIsModalOpen(true)}>
                  <i className={selectedIcon}></i>
                  <span>{allIcons.find(i => i.icon === selectedIcon)?.label.split(' ')[0] || 'Pick Icon'}</span>
                </div>
              </div>

              <div className="input-group">
                <label>Actual Price (₹)</label>
                <input type="number" value={actualPrice} onChange={(e)=>setActualPrice(e.target.value)} required />
              </div>

              <div className="input-group">
                <label>Offer Price (₹)</label>
                <input type="number" value={offerPrice} onChange={(e)=>setOfferPrice(e.target.value)} required />
              </div>

              <button type="submit" className="submit-btn" disabled={loading}>
                {loading ? 'Saving...' : 'Add Service'}
              </button>
            </div>
          </form>
        </div>
      </section>

      {/* Table Section */}
      <section className="table-section">
        <div className="table-card">
          <div className="table-header">
            <h3><i className="fas fa-list"></i> Service Price List</h3>
          </div>
          <div className="table-responsive">
            <table className="modern-admin-table">
              <thead>
                <tr>
                  <th>Sl No.</th>
                  <th>Icon</th>
                  <th>Service Name</th>
                  <th>Actual Price</th>
                  <th>Offer Price</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {services.map((service, index) => (
                  <tr key={service.id}>
                    <td>{index + 1}</td>
                    <td><div className="table-icon-circle"><i className={service.icon}></i></div></td>
                    <td className="service-name-cell">{service.name}</td>
                    <td className="price-old">₹{service.actualPrice}</td>
                    <td className="price-new">₹{service.offerPrice}</td>
                    <td className="text-center">
                      <button onClick={() => handleDelete(service.id)} className="delete-action-btn">
                        <i className="fas fa-trash-alt"></i> Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Modern Icon Selector Modal */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="modern-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-head">
              <h4>Search & Select Icon</h4>
              <button className="close-x" onClick={() => setIsModalOpen(false)}>&times;</button>
            </div>
            
            <div className="modal-search">
              <i className="fas fa-search"></i>
              <input 
                type="text" 
                placeholder="Try searching 'wash', 'iron', 'shoe'..." 
                value={iconSearchTerm}
                onChange={(e) => setIconSearchTerm(e.target.value)}
                autoFocus
              />
            </div>

            <div className="icon-grid-scrollable">
              {filteredIcons.length > 0 ? (
                filteredIcons.map((item, idx) => (
                  <div 
                    key={idx} 
                    className={`icon-grid-item ${selectedIcon === item.icon ? 'active' : ''}`}
                    onClick={() => { 
                        setSelectedIcon(item.icon); 
                        setIsModalOpen(false); 
                        setIconSearchTerm(''); 
                    }}
                  >
                    <i className={item.icon}></i>
                    <span>{item.label.split(' ')[0]}</span>
                  </div>
                ))
              ) : (
                <div className="no-icons-found">
                    <i className="fas fa-search-minus"></i>
                    <p>No icons found for "{iconSearchTerm}"</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AddServices;